<template>
  <component
    :is="compType"
    class="list list--inline"
    :class="{'with-lead' : withLead, 'with-padding': withPadding, 'big-padding': withBigPadding, 'central': central, 'inner-padding': withInnerPadding}"
  >
    <slot></slot>
  </component>
</template>

<script>
export default {
  props: {
    ordered: {
      type: Boolean,
      default: true
    },
    withLead: Boolean,
    withPadding: Boolean,
    withBigPadding: Boolean,
    withInnerPadding: Boolean,
    central: Boolean
  },
  computed: {
    compType() {
      return this.ordered ? "ol" : "ul";
    }
  }
};
</script>

<style scoped lang="scss">
.list {
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  &--inline {
    li {
      margin: 0;
      padding: 0;
      display: inline-flex;
      list-style-type: none;
    }
  }

  &.with-lead {
    border-left: 3px solid $colour-cactus-core-green;
    padding-left: 10px;
  }

  &.with-padding {
    li {
      box-sizing: border-box;
      padding: 0 0 10px 0;

      @media (min-width: 768px) {
        padding-right: 10px;
      }
    }
  }

  &.big-padding {
    li {
      box-sizing: border-box;
      padding: 0 20px 0 0;
    }
  }

  &.central {
    justify-content: center;
  }

  &.inner-padding {
    li {
      padding-right: 10px;

      &:last-of-type {
        padding-right: 0;
      }
    }
  }
}

.bordered {
  border: 1px solid $colour-nhs-pale-grey;
  // border-radius: 2em;
  li {
    &:last-of-type {
      border-right: 0;
    }
    border-right: 1px solid $colour-nhs-pale-grey;
  }
}
</style>
